export function isValid(code: string | number) {
  return (
    !!code && // que no sea null o undefined
    !isNaN(Number(code)) && // que sea un número válido
    Number(code) > 0 && // que sea mayor a 0
    Number(code) >= 200 && // que sea mayor o igual a 200
    Number(code) < 300 // que sea menor a 300
  );
}
